exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#logo[data-v-6fa2ea1b]{width:100%;max-width:30rem}", ""]);

// exports
